import React, { useState } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';

import { IconButton } from '@material-ui/core';
import { Fullscreen, FullscreenExit } from '@material-ui/icons';

import { Card, Filter } from '../components';
import * as S from '../styles';

export default function EstoquePostoMonitorFullscreen() {
  const [params, setParams] = useState({});

  const handle = useFullScreenHandle();

  return (
    <FullScreen handle={handle}>
      <S.WrapperFullScreen>
        <S.Header>
          {/* <Filter onCallback={setParams} /> */}
          {handle.active ? (
            <IconButton
              aria-label="Fechar janela em tela cheia"
              onClick={handle.exit}
            >
              <FullscreenExit />
            </IconButton>
          ) : (
            <IconButton
              aria-label="Abrir janela em tela cheia"
              onClick={handle.enter}
            >
              <Fullscreen />
            </IconButton>
          )}
        </S.Header>
        <Card params={params} />
      </S.WrapperFullScreen>
    </FullScreen>
  );
}
